/*
 * @Author: mikey.zhaopeng
 * @Date: 2021-07-07 11:02:22
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2021-07-07 11:21:58
 */

import YxNumber from "./Number";
import PropTypes from "prop-types";
import { ITextBasePropTypes } from "../IpropType/basePropTypes";
YxNumber.propTypes = {
  ...ITextBasePropTypes,
  type: PropTypes.oneOf(["int", "float", "amount"]),
  //金额类型，开启后，自动添加单位和金钱符号，RMB（自动添加￥ 元），USD（$ dollar）,GBP（￡ pound）EUR（€ euro）
  amountType: PropTypes.string,

  isShowSymbolBefore: PropTypes.bool,
  isShowSymbolAfter: PropTypes.bool,
  beforeStrClass: PropTypes.string,

  afterStrClass: PropTypes.string,
  precision: PropTypes.number,

  isRounding: PropTypes.bool,

  isThousand: PropTypes.bool,

  amountTypeExtra: PropTypes.object,
  isComma: PropTypes.bool,
};
YxNumber.defaultProps = {
  type: "int", //int/float/amount
  amountType: "RMB", //金额类型
  isShowSymbolBefore: true, //是否显示金额前面的内容，比如 ￥,只有指定金额类型才会显示,可以选择不显示
  isShowSymbolAfter: true, //是否显示金额后面的内容，比如 ￥,只有指定金额类型才会显示,可以选择不显示
  beforeStrClass: "", //前置内容的样式
  afterStrClass: "", //后置内容的样式
  precision: 0, //保留几位小数
  isRounding: true, //是否开启四舍五入
  isThousand: true, //是否开启千分位处理
  amountTypeExtra: {}, //金额类型列表 示例：{ "RMB",{moneySymbol:'￥', moneyCompany:'元'},... }
};

export default YxNumber;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxText/Number/index.js